import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pinecone = defineConnector({
  identifier: "pinecone",
  name: "Pinecone",
  tagLine: "Vector database",
  logo,
  protocol: "http",
  tags: ["ai", "data", "engineering", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.pinecone\\.io/.*",
  auth: (app) => headerAuth([{ name: "Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [Pinecone Console](https://app.pinecone.io/) and navigate to **API Keys** to create or copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "pcsk_…",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pinecone.io/indexes",
  },
});
